<template>
  <v-app class="gov-app rekap-app">
    <div class="gov-background"></div>

    <v-app-bar app flat class="gov-header no-print">
      <v-btn icon color="#41505A" @click="$router.back()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <div class="ml-2">
        <v-toolbar-title class="gov-title">
          Rekap Potensi Desa Bondowoso
        </v-toolbar-title>
      </div>

      <v-spacer></v-spacer>

      <div class="d-none d-md-flex align-center mr-4 gov-updated">
        <span class="grey--text text--darken-1 mr-1">Diperbarui:</span>
        <span class="font-weight-bold">{{ lastUpdatedText || "-" }}</span>
        <v-btn
          icon
          x-small
          class="ml-1"
          :loading="loading"
          @click="loadData"
          title="Muat ulang"
        >
          <v-icon small color="#018c74">mdi-refresh</v-icon>
        </v-btn>
      </div>

      <v-btn class="gov-btn-primary mr-2 d-none d-sm-flex" depressed @click="goToPeta">
        <v-icon left small color="#f9fdfd">mdi-map-marker-radius</v-icon>
        Lihat Peta
      </v-btn>

      <v-btn
        icon
        color="#41505A"
        :loading="exportLoading"
        @click="exportExcel"
        title="Unduh Excel"
      >
        <v-icon>mdi-file-excel-outline</v-icon>
      </v-btn>

      <v-btn icon color="#41505A" @click="printPage" title="Cetak">
        <v-icon>mdi-printer-outline</v-icon>
      </v-btn>

      <v-menu offset-y left>
        <template #activator="{ on, attrs }">
          <v-btn icon color="#41505A" v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="loadData">
            <v-list-item-icon class="mr-2"
              ><v-icon small>mdi-refresh</v-icon></v-list-item-icon
            >
            <v-list-item-title>Muat Ulang Data</v-list-item-title>
          </v-list-item>
          <v-list-item @click="exportExcel">
            <v-list-item-icon class="mr-2"
              ><v-icon small>mdi-file-excel-outline</v-icon></v-list-item-icon
            >
            <v-list-item-title>Unduh Excel (.xlsx)</v-list-item-title>
          </v-list-item>
          <v-list-item @click="printPage">
            <v-list-item-icon class="mr-2"
              ><v-icon small>mdi-printer-outline</v-icon></v-list-item-icon
            >
            <v-list-item-title>Cetak Halaman</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container fluid class="px-4 px-md-6 pt-3 pb-10">
        <div
          v-if="loading"
          class="d-flex flex-column align-center justify-center loading-box"
        >
          <v-progress-circular indeterminate color="#018c74" size="54" width="4" />
          <div class="mt-4 grey--text">Memuat data potensi desa...</div>
        </div>

        <v-alert
          v-else-if="!totalPotensi"
          type="warning"
          border="left"
          colored-border
          elevation="2"
          class="gov-card mt-4"
        >
          <div class="font-weight-bold mb-1">Data belum tersedia</div>
          <div class="text-body-2">
            {{ errorMsg || "Belum ada data potensi desa yang bisa direkap saat ini." }}
            Silakan buka halaman <strong>Peta Potensi Desa</strong> terlebih dahulu, atau
            muat ulang halaman ini.
          </div>
          <v-btn small class="gov-btn-primary mt-3" @click="loadData">
            <v-icon left small>mdi-refresh</v-icon> Muat Ulang
          </v-btn>
        </v-alert>

        <template v-else>
          <div class="gov-card filter-bar pa-4 mb-4 no-print">
            <v-row dense align="center">
              <v-col cols="6" sm="4" md="2">
                <div class="filter-label">Kategori</div>
                <v-select
                  v-model="selectedKategori"
                  :items="categoryStats.map((c) => c.nama)"
                  dense
                  outlined
                  hide-details
                  clearable
                  placeholder="Semua"
                  class="gov-select"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="filter-label">Jenis Potensi</div>
                <v-select
                  v-model="filterJenis"
                  :items="jenisOptions"
                  dense
                  outlined
                  hide-details
                  clearable
                  placeholder="Semua"
                  class="gov-select"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="2">
                <div class="filter-label">Desa</div>
                <v-select
                  v-model="filterDesa"
                  :items="desaOptions"
                  item-text="text"
                  item-value="value"
                  dense
                  outlined
                  hide-details
                  clearable
                  placeholder="Semua"
                  class="gov-select"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="6">
                <div class="filter-label">&nbsp;</div>
                <v-text-field
                  v-model="search"
                  dense
                  outlined
                  hide-details
                  clearable
                  placeholder="Cari desa..."
                  prepend-inner-icon="mdi-magnify"
                  class="gov-select"
                ></v-text-field>
              </v-col>
            </v-row>
            <div class="d-flex align-center mt-2" v-if="activeFilterCount">
              <v-icon x-small color="#018c74" class="mr-1">mdi-filter-variant</v-icon>
              <span class="text-caption grey--text text--darken-1 mr-2">
                {{ activeFilterCount }} filter aktif
              </span>
              <v-btn x-small text color="#018c74" @click="clearFilters"
                >Bersihkan filter</v-btn
              >
            </div>
          </div>

          <v-row class="mt-1">
            <v-col cols="6" sm="4" md="2">
              <div class="stat-card">
                <div class="stat-icon-box" style="background: rgba(1, 140, 116, 0.09)">
                  <v-icon color="#018c74" size="24">mdi-map-marker-multiple</v-icon>
                </div>
                <div class="stat-number">{{ totalPotensi }}</div>
                <div class="stat-label">Total Potensi</div>
              </div>
            </v-col>

            <v-col cols="6" sm="4" md="2">
              <div class="stat-card">
                <div class="stat-icon-box" style="background: #1e88e518">
                  <v-icon color="#1E88E5" size="24">mdi-home-group</v-icon>
                </div>
                <div class="stat-number">{{ totalDesa }}</div>
                <div class="stat-label">
                  Desa Terdata
                  <span class="stat-sublabel"
                    >{{ cakupanDesaPercent }}% dari {{ totalDesaBondowoso }}</span
                  >
                </div>
              </div>
            </v-col>

            <v-col cols="6" sm="4" md="2">
              <div class="stat-card">
                <div class="stat-icon-box" style="background: #7c4dff18">
                  <v-icon color="#7C4DFF" size="24"
                    >mdi-office-building-marker-outline</v-icon
                  >
                </div>
                <div class="stat-number">219</div>
                <div class="stat-label">
                  Desa
                </div>
              </div>
            </v-col>

            <v-col cols="6" sm="4" md="2">
              <div class="stat-card">
                <div class="stat-icon-box" style="background: #cfa22d18">
                  <v-icon color="#CFA22D" size="24">mdi-shape-outline</v-icon>
                </div>
                <div class="stat-number">{{ categoryStats.length }}</div>
                <div class="stat-label">Kategori</div>
              </div>
            </v-col>

            <v-col cols="6" sm="4" md="2">
              <div class="stat-card">
                <div class="stat-icon-box" style="background: #00bcd418">
                  <v-icon color="#00BCD4" size="24">mdi-layers-outline</v-icon>
                </div>
                <div class="stat-number">{{ jenisOptions.length }}</div>
                <div class="stat-label">Jenis Potensi</div>
              </div>
            </v-col>

            <v-col cols="6" sm="4" md="2">
              <div class="stat-card">
                <div class="stat-icon-box" style="background: #e9436418">
                  <v-icon color="#E94364" size="24">mdi-calendar-check-outline</v-icon>
                </div>
                <div class="stat-number stat-number-text">
                  {{ lastUpdatedShort || "-" }}
                </div>
                <div class="stat-label">Update Terakhir</div>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" lg="8">
              <div class="gov-card pa-0 map-card-wrap">
                <div class="d-flex align-center flex-wrap pa-4 pb-2">
                  <div>
                    <div class="text-h6 font-weight-bold">Sebaran Potensi per Desa</div>
                    <div class="text-caption grey--text">
                      Klik pada desa untuk memfilter data
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-chip
                    v-if="filterDesa"
                    close
                    small
                    color="#018c74"
                    text-color="white"
                    @click:close="filterDesa = null"
                  >
                    {{ filterDesaLabel }}
                  </v-chip>
                </div>

                <div class="map-shell">
                  <div id="rekap-map"></div>

                  <div v-if="mapLoading" class="map-loading-overlay">
                    <v-progress-circular
                      indeterminate
                      color="#018c74"
                      size="34"
                      width="3"
                    />
                  </div>

                  <div class="map-legend-box" v-if="legendBuckets.length">
                    <div class="text-overline grey--text mb-1">Jumlah Potensi</div>
                    <div class="legend-row" v-for="b in legendBuckets" :key="b.label">
                      <span class="legend-swatch" :style="{ background: b.color }"></span>
                      <span>{{ b.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" lg="4">
              <div class="gov-card pa-4 insight-card h-100">
                <div class="d-flex align-center mb-3">
                  <v-icon color="#CFA22D" class="mr-2">mdi-lightbulb-on-outline</v-icon>
                  <div class="text-h6 font-weight-bold">Kesimpulan</div>
                </div>

                <div v-if="!autoInsights.length" class="text-caption grey--text">
                  Belum dapat diambil kesimpulant.
                </div>

                <div v-for="(ins, i) in autoInsights" :key="i" class="insight-row">
                  <v-icon small :color="ins.color">{{ ins.icon }}</v-icon>
                  <div class="insight-text" v-html="ins.text"></div>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" md="6">
              <div class="gov-card pa-4 h-100 d-flex flex-column">
                <div class="text-h6 font-weight-bold mb-3">
                  Distribusi Potensi per Kategori
                </div>
                <div class="donut-wrap">
                  <svg viewBox="0 0 200 200" class="donut-svg">
                    <circle
                      v-for="seg in donutSegments"
                      :key="seg.nama"
                      cx="100"
                      cy="100"
                      r="80"
                      fill="none"
                      :stroke="seg.color"
                      stroke-width="26"
                      :stroke-dasharray="seg.dashArray"
                      :stroke-dashoffset="seg.dashOffset"
                      transform="rotate(-90 100 100)"
                    />
                  </svg>
                  <div class="donut-center">
                    <div class="donut-total">{{ totalPotensi }}</div>
                    <div class="donut-total-label">Titik</div>
                  </div>
                </div>
                <div class="donut-legend">
                  <div
                    v-for="seg in donutSegments"
                    :key="'legend-' + seg.nama"
                    class="donut-legend-row"
                    :class="{ 'is-active': selectedKategori === seg.nama }"
                    @click="toggleKategoriFilter(seg.nama)"
                  >
                    <span class="legend-swatch" :style="{ background: seg.color }"></span>
                    <span class="donut-legend-label">{{ seg.nama }}</span>
                    <span class="donut-legend-value"
                      >{{ seg.count }} ({{ seg.percent }}%)</span
                    >
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6">
              <div class="gov-card pa-4 h-100">
                <div class="text-h6 font-weight-bold mb-3">Top 5 Jenis Potensi</div>
                <div
                  v-for="(j, i) in topJenis"
                  :key="j.nama"
                  class="rank-row"
                  :class="{ 'is-active': filterJenis === j.nama }"
                  @click="toggleJenisFilter(j.nama)"
                >
                  <v-icon small :color="categoryColor(j.kategori)" class="mr-1">{{
                    categoryIcon(j.kategori)
                  }}</v-icon>
                  <div class="rank-label">{{ j.nama }}</div>
                  <div class="rank-track">
                    <div
                      class="rank-fill"
                      :style="{
                        width: j.percent + '%',
                        background: categoryColor(j.kategori),
                      }"
                    ></div>
                  </div>
                  <div class="rank-count">{{ j.count }}</div>
                </div>
                <div v-if="!topJenis.length" class="text-caption grey--text">
                  Belum ada data jenis potensi.
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" md="4">
              <div class="gov-card pa-4 h-100">
                <div class="text-h6 font-weight-bold mb-3">Top 5 Desa</div>
                <div
                  v-for="(d, i) in topDesa"
                  :key="d.key"
                  class="top-desa-row"
                  @click="filterDesa = d.key"
                >
                  <div class="top-desa-medal" :class="'medal-' + (i + 1)">
                    {{ i + 1 }}
                  </div>
                  <div class="top-desa-info">
                    <div class="top-desa-name">{{ d.nama_desa }}</div>
                    <div class="top-desa-kec" v-if="d.kecamatan">
                      {{ d.kecamatan }}
                    </div>
                  </div>
                  <div class="top-desa-count">{{ d.total }}</div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="4">
              <div class="gov-card pa-4 h-100">
                <div class="text-h6 font-weight-bold mb-3">Kelengkapan Data</div>
                <div v-for="c in kelengkapanStats" :key="c.label" class="kelengkapan-row">
                  <v-icon small :color="c.color" class="mr-2">{{ c.icon }}</v-icon>
                  <div class="kelengkapan-label">{{ c.label }}</div>
                  <div class="kelengkapan-track">
                    <div
                      class="kelengkapan-fill"
                      :style="{ width: c.percent + '%', background: c.color }"
                    ></div>
                  </div>
                  <div class="kelengkapan-value">{{ c.percent }}%</div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="4">
              <div
                class="gov-card pa-4 h-100 belum-terdata-card belum-terdata-clickable"
                v-if="desaBelumTerdata.length"
                @click="openBelumTerdataDialog()"
              >
                <div class="d-flex align-center mb-2">
                  <v-icon color="#E94364" class="mr-2">mdi-alert-circle-outline</v-icon>
                  <div class="text-h6 font-weight-bold">Desa Belum Terdata</div>
                  <v-spacer></v-spacer>
                  <v-icon small color="#E94364">mdi-chevron-right</v-icon>
                </div>
                <div class="text-caption mb-3">
                  Masih ada {{ desaBelumTerdata.length }} desa belum memiliki data potensi
                </div>
                <ul class="belum-terdata-list">
                  <li
                    v-for="v in desaBelumTerdata.slice(0, 6)"
                    :key="v.key"
                    class="belum-terdata-item"
                    @click.stop="openBelumTerdataDialog(v.nama)"
                  >
                    Desa {{ v.nama }}
                    <span v-if="v.kecamatan" class="belum-terdata-kec"
                      >(Kec. {{ v.kecamatan }})</span
                    >
                  </li>
                </ul>
                <div
                  v-if="desaBelumTerdata.length > 6"
                  class="text-caption mt-2 belum-terdata-more"
                >
                  Lihat semua {{ desaBelumTerdata.length }} desa
                  <v-icon x-small color="#018c74">mdi-arrow-right</v-icon>
                </div>
              </div>
              <div
                class="gov-card pa-4 h-100 d-flex flex-column align-center justify-center"
                v-else
              >
                <v-icon color="#018c74" size="40">mdi-check-decagram-outline</v-icon>
                <div class="text-body-2 grey--text mt-2 text-center">
                  Seluruh desa yang terdaftar pada batas wilayah sudah memiliki data
                  potensi.
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12">
              <div class="gov-card pa-2 pa-sm-4">
                <div class="d-flex align-center px-2 pt-2 pb-1 flex-wrap">
                  <div>
                    <div class="text-h6 font-weight-bold">Rekap Potensi per Desa</div>
                    <div class="text-caption grey--text">
                      Menampilkan {{ filteredDesaRekap.length }} dari
                      {{ desaRekap.length }} desa
                    </div>
                  </div>
                  <v-spacer></v-spacer>
                  <v-select
                    v-model="sortBy"
                    dense
                    outlined
                    hide-details
                    :items="sortOptions"
                    class="gov-select sort-select no-print"
                    style="max-width: 220px"
                  ></v-select>
                </div>

                <v-data-table
                  :headers="headers"
                  :items="filteredDesaRekap"
                  :expanded.sync="expanded"
                  item-key="key"
                  show-expand
                  class="rekap-table"
                  :items-per-page="10"
                  :footer-props="{ itemsPerPageOptions: [10, 25, 50, -1] }"
                  no-data-text="Tidak ada desa yang cocok dengan pencarian/filter"
                >
                  <template #item.no="{ item }">
                    {{ item.no }}
                  </template>

                  <template #item.nama_desa="{ item }">
                    <div class="font-weight-bold">{{ item.nama_desa }}</div>
                  </template>

                  <template #item.kecamatan="{ item }">
                    <span class="grey--text text--darken-2">{{
                      item.kecamatan || "-"
                    }}</span>
                  </template>

                  <template #item.total="{ item }">
                    <v-chip
                      small
                      color="#018c74"
                      text-color="white"
                      class="font-weight-bold"
                    >
                      {{ item.total }}
                    </v-chip>
                  </template>

                  <template #item.topKategori="{ item }">
                    <v-chip small outlined :color="categoryColor(item.topKategori)">
                      {{ item.topKategori }}
                    </v-chip>
                  </template>

                  <template #item.rincian="{ item }">
                    <div class="d-flex flex-wrap" style="gap: 4px">
                      <v-chip
                        v-for="k in item.rincianTampil"
                        :key="k.nama"
                        x-small
                        :color="categoryColor(k.nama) + '20'"
                        :text-color="categoryColor(k.nama)"
                      >
                        {{ k.nama }}: {{ k.count }}
                      </v-chip>
                      <v-chip v-if="item.rincianSisa > 0" x-small outlined color="grey">
                        +{{ item.rincianSisa }} lainnya
                      </v-chip>
                    </div>
                  </template>

                  <template #expanded-item="{ headers: h, item }">
                    <td :colspan="h.length" class="pa-4 detail-desa-cell">
                      <div class="text-subtitle-2 font-weight-bold mb-2">
                        Rincian Titik Potensi di Desa {{ item.nama_desa }}
                        <span v-if="item.kecamatan" class="grey--text font-weight-regular"
                          >(Kec. {{ item.kecamatan }})</span
                        >
                      </div>
                      <v-row>
                        <v-col
                          v-for="detail in item.items"
                          :key="detail.id"
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <div class="detail-item-card" @click="openDetail(detail)">
                            <div class="d-flex align-center mb-1">
                              <v-icon
                                small
                                :color="categoryColor(detail.nama_kategori)"
                                class="mr-1"
                              >
                                {{ categoryIcon(detail.nama_kategori) }}
                              </v-icon>
                              <span class="text-caption font-weight-bold">{{
                                detail.nama_kategori
                              }}</span>
                            </div>
                            <div class="font-weight-bold text-body-2">
                              {{ detail.toponim || detail.nama_sub_jenis || "-" }}
                            </div>
                            <div v-if="detail.alamat" class="text-caption grey--text">
                              <v-icon x-small>mdi-map-marker</v-icon> {{ detail.alamat }}
                            </div>
                            <div class="text-right mt-1">
                              <v-btn x-small text color="#018c74" class="detail-btn">
                                Detail
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-main>

    <v-dialog
      v-model="detailDialog"
      max-width="620"
      width="95%"
      transition="dialog-bottom-transition"
    >
      <v-card v-if="detailItem" class="detail-dialog-card">
        <div class="hero-media">
          <v-btn
            fab
            x-small
            elevation="3"
            color="white"
            class="close-btn"
            @click="closeDetail"
          >
            <v-icon color="#333"> mdi-close </v-icon>
          </v-btn>

          <template v-if="detailMedia.length">
            <v-carousel
              v-model="detailCarouselIndex"
              height="240"
              hide-delimiter-background
              :show-arrows="detailMedia.length > 1"
              :hide-delimiters="detailMedia.length <= 1"
              class="hero-carousel"
            >
              <v-carousel-item v-for="(media, i) in detailMedia" :key="i">
                <img v-if="media.type == 'image'" :src="media.url" class="hero-img" />

                <video
                  v-else
                  controls
                  preload="metadata"
                  playsinline
                  class="hero-video"
                  :src="media.url"
                ></video>

                <div class="media-type">
                  <v-icon x-small color="white">
                    {{ media.type == "video" ? "mdi-play-circle" : "mdi-image" }}
                  </v-icon>
                  <span>
                    {{ media.type == "video" ? "Video" : "Foto" }}
                  </span>
                </div>

                <div class="media-count">{{ i + 1 }} / {{ detailMedia.length }}</div>
              </v-carousel-item>
            </v-carousel>
          </template>

          <template v-else>
            <div class="no-media">
              <v-icon size="70" color="grey lighten-1"> mdi-image-off-outline </v-icon>
              <div class="mt-3 grey--text">Belum ada foto / video</div>
            </div>
          </template>
        </div>

        <div class="pa-5">
          <div class="detail-title">
            {{ detailItem.nama }}
          </div>

          <div class="mt-2">
            <v-chip x-small color="#018c74" dark>
              {{ detailItem.nama_kategori }}
            </v-chip>

            <v-chip x-small outlined class="ml-1" v-if="detailItem.nama_jenis">
              {{ detailItem.nama_jenis }}
            </v-chip>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="info-row" v-if="detailItem.alamat">
            <v-icon small color="#018c74"> mdi-map-marker </v-icon>
            <span>
              {{ detailItem.alamat }}
            </span>
          </div>

          <div class="info-row" v-if="detailItem.nama_desa_raw">
            <v-icon small color="#018c74"> mdi-home-city </v-icon>
            <span>
              Desa {{ detailItem.nama_desa_raw
              }}<template v-if="detailItem.kecamatan">
                , Kec. {{ detailItem.kecamatan }}</template
              >
            </span>
          </div>

          <div class="info-row" v-if="detailItem.pic">
            <v-icon small color="#018c74"> mdi-account-circle </v-icon>
            <span>
              {{ detailItem.pic }}
            </span>
          </div>

          <div class="description" v-if="detailItem.deskripsi">
            {{ detailItem.deskripsi }}
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="belumTerdataDialog" max-width="520" width="95%">
      <v-card class="belum-terdata-dialog-card">
        <div class="d-flex align-center pa-4 pb-2">
          <v-icon color="#E94364" class="mr-2">mdi-alert-circle-outline</v-icon>
          <div class="text-h6 font-weight-bold">Desa Belum Terdata</div>
          <v-spacer></v-spacer>
          <v-btn icon small @click="belumTerdataDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="px-4 text-caption grey--text mb-2">
          {{ desaBelumTerdata.length }} desa di Kabupaten Bondowoso belum memiliki data
          potensi.
        </div>
        <div class="px-4 pb-2">
          <v-text-field
            v-model="belumTerdataSearch"
            dense
            outlined
            hide-details
            clearable
            placeholder="Cari nama desa..."
            prepend-inner-icon="mdi-magnify"
            class="gov-select"
          ></v-text-field>
        </div>
        <v-divider></v-divider>
        <div class="belum-terdata-dialog-list px-2 py-2">
          <div
            v-for="v in filteredBelumTerdata"
            :key="v.key"
            class="belum-terdata-dialog-row"
          >
            <v-icon small color="#E94364" class="mr-3">mdi-map-marker-off-outline</v-icon>
            <div class="flex-grow-1">
              <div class="font-weight-bold">Desa {{ v.nama }}</div>
              <div class="text-caption grey--text" v-if="v.kecamatan">
                Kecamatan {{ v.kecamatan }}
              </div>
            </div>
          </div>
          <div
            v-if="!filteredBelumTerdata.length"
            class="text-caption grey--text text-center py-6"
          >
            Tidak ada desa yang cocok dengan pencarian.
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import ExcelJS from "exceljs";
import { getPotensiSpasial } from "@/api/androidInitApi";

const MEDIA_BASE_URL = "https://berkah.bondowosokab.go.id:5500/uploads/";

const TOTAL_DESA_KELURAHAN_BONDOWOSO = 219;
const TOTAL_KECAMATAN_BONDOWOSO = 23;

const CATEGORY_COLOR_PALETTE = [
  "#018c74",
  "#1E88E5",
  "#CFA22D",
  "#7C4DFF",
  "#E94364",
  "#00BCD4",
  "#FF9800",
  "#8BC34A",
  "#607D8B",
  "#9C27B0",
];

const MAP_COLOR_SCALE = ["#E4F2EE", "#B7DFD4", "#7CC4AF", "#3CA487", "#016B57"];
const KECAMATAN_CODE_MAP = {
  "35.11.01": "Maesan",
  "35.11.02": "Tamanan",
  "35.11.03": "Tlogosari",
  "35.11.04": "Sukosari",
  "35.11.05": "Pujer",
  "35.11.06": "Grujugan",
  "35.11.07": "Curahdami",
  "35.11.08": "Tenggarang",
  "35.11.09": "Wonosari",
  "35.11.10": "Tapen",
  "35.11.11": "Bondowoso",
  "35.11.12": "Wringin",
  "35.11.13": "Tegalampel",
  "35.11.14": "Klabang",
  "35.11.15": "Cermee",
  "35.11.16": "Prajekan",
  "35.11.17": "Pakem",
  "35.11.18": "Sumber Wringin",
  "35.11.19": "Ijen",
  "35.11.20": "Binakal",
  "35.11.21": "Taman Krocok",
  "35.11.22": "Botolinggo",
  "35.11.23": "Jambesari Darus Sholah",
};

const DESA_ID_TO_KODE_BPS = {
  220: "35.11.01.2001",
  221: "35.11.01.2002",
  222: "35.11.01.2003",
  223: "35.11.01.2004",
  224: "35.11.01.2005",
  225: "35.11.01.2006",
  226: "35.11.01.2007",
  227: "35.11.01.2008",
  228: "35.11.01.2009",
  229: "35.11.01.2010",
  230: "35.11.01.2011",
  231: "35.11.01.2012",
  232: "35.11.02.2001",
  233: "35.11.02.2002",
  234: "35.11.02.2003",
  235: "35.11.02.2004",
  236: "35.11.02.2005",
  237: "35.11.02.2006",
  238: "35.11.02.2007",
  239: "35.11.02.2008",
  240: "35.11.02.2009",
  242: "35.11.03.2002",
  243: "35.11.03.2003",
  244: "35.11.03.2004",
  245: "35.11.03.2005",
  246: "35.11.03.2006",
  247: "35.11.03.2007",
  248: "35.11.03.2008",
  249: "35.11.03.2009",
  250: "35.11.03.2010",
  251: "35.11.04.2001",
  252: "35.11.04.2002",
  253: "35.11.04.2003",
  254: "35.11.04.2004",
  255: "35.11.05.2001",
  256: "35.11.05.2002",
  257: "35.11.05.2003",
  258: "35.11.05.2004",
  259: "35.11.05.2005",
  260: "35.11.05.2006",
  261: "35.11.05.2007",
  262: "35.11.05.2008",
  263: "35.11.05.2009",
  264: "35.11.05.2010",
  265: "35.11.05.2011",
  266: "35.11.06.2001",
  267: "35.11.06.2002",
  268: "35.11.06.2003",
  269: "35.11.06.2004",
  270: "35.11.06.2005",
  271: "35.11.06.2006",
  272: "35.11.06.2007",
  273: "35.11.06.2008",
  274: "35.11.06.2009",
  275: "35.11.06.2010",
  276: "35.11.06.2011",
  277: "35.11.07.2001",
  278: "35.11.07.2002",
  279: "35.11.07.2003",
  280: "35.11.07.2004",
  281: "35.11.07.2005",
  282: "35.11.07.2006",
  283: "35.11.07.2007",
  284: "35.11.07.2008",
  285: "35.11.07.2009",
  286: "35.11.07.2010",
  287: "35.11.07.2011",
  288: "35.11.07.2012",
  289: "35.11.08.2001",
  290: "35.11.08.2002",
  291: "35.11.08.2003",
  292: "35.11.08.2004",
  293: "35.11.08.2005",
  294: "35.11.08.2006",
  295: "35.11.08.2007",
  296: "35.11.08.2008",
  297: "35.11.08.2009",
  298: "35.11.08.2010",
  299: "35.11.08.2011",
  300: "35.11.08.2012",
  301: "35.11.09.2001",
  302: "35.11.09.2002",
  303: "35.11.09.2003",
  304: "35.11.09.2004",
  305: "35.11.09.2005",
  306: "35.11.09.2006",
  307: "35.11.09.2007",
  308: "35.11.09.2008",
  309: "35.11.09.2009",
  310: "35.11.09.2010",
  311: "35.11.09.2011",
  312: "35.11.09.2012",
  313: "35.11.10.2001",
  314: "35.11.10.2002",
  315: "35.11.10.2003",
  316: "35.11.10.2004",
  317: "35.11.10.2005",
  318: "35.11.10.2006",
  319: "35.11.10.2007",
  320: "35.11.10.2008",
  321: "35.11.10.2009",
  322: "35.11.11.1004",
  323: "35.11.11.1005",
  324: "35.11.11.1006",
  325: "35.11.11.1007",
  326: "35.11.11.1008",
  327: "35.11.11.1009",
  328: "35.11.11.1010",
  329: "35.11.11.2001",
  330: "35.11.11.2002",
  331: "35.11.11.2003",
  332: "35.11.11.2011",
  333: "35.11.12.2001",
  334: "35.11.12.2002",
  335: "35.11.12.2003",
  336: "35.11.12.2004",
  337: "35.11.12.2005",
  338: "35.11.12.2006",
  339: "35.11.12.2007",
  340: "35.11.12.2008",
  341: "35.11.12.2009",
  342: "35.11.12.2010",
  343: "35.11.12.2011",
  344: "35.11.12.2012",
  345: "35.11.12.2013",
  346: "35.11.13.2001",
  347: "35.11.13.2002",
  348: "35.11.13.2003",
  349: "35.11.13.2004",
  350: "35.11.13.2005",
  351: "35.11.13.2006",
  352: "35.11.13.2007",
  353: "35.11.13.2008",
  354: "35.11.14.2001",
  355: "35.11.14.2002",
  356: "35.11.14.2003",
  357: "35.11.14.2004",
  358: "35.11.14.2005",
  359: "35.11.14.2006",
  360: "35.11.14.2007",
  361: "35.11.14.2008",
  362: "35.11.14.2009",
  363: "35.11.14.2010",
  364: "35.11.14.2011",
  365: "35.11.15.2001",
  366: "35.11.15.2002",
  367: "35.11.15.2003",
  368: "35.11.15.2004",
  369: "35.11.15.2005",
  370: "35.11.15.2006",
  371: "35.11.15.2007",
  372: "35.11.15.2008",
  373: "35.11.15.2009",
  374: "35.11.15.2010",
  375: "35.11.15.2011",
  376: "35.11.15.2012",
  377: "35.11.15.2013",
  378: "35.11.15.2014",
  379: "35.11.15.2015",
  380: "35.11.16.2001",
  381: "35.11.16.2002",
  382: "35.11.16.2003",
  383: "35.11.16.2004",
  384: "35.11.16.2005",
  385: "35.11.16.2006",
  386: "35.11.16.2007",
  387: "35.11.17.2001",
  388: "35.11.17.2002",
  389: "35.11.17.2003",
  390: "35.11.17.2004",
  391: "35.11.17.2005",
  392: "35.11.17.2006",
  393: "35.11.17.2007",
  394: "35.11.17.2008",
  395: "35.11.18.2001",
  396: "35.11.18.2002",
  397: "35.11.18.2003",
  398: "35.11.18.2004",
  399: "35.11.18.2005",
  400: "35.11.18.2006",
  401: "35.11.19.2001",
  402: "35.11.19.2002",
  403: "35.11.19.2003",
  404: "35.11.19.2004",
  405: "35.11.19.2005",
  406: "35.11.19.2006",
  407: "35.11.20.2001",
  408: "35.11.20.2002",
  409: "35.11.20.2003",
  410: "35.11.20.2004",
  411: "35.11.20.2005",
  412: "35.11.20.2006",
  413: "35.11.20.2007",
  414: "35.11.20.2008",
  415: "35.11.21.2001",
  416: "35.11.21.2002",
  417: "35.11.21.2003",
  418: "35.11.21.2004",
  419: "35.11.21.2005",
  420: "35.11.21.2006",
  421: "35.11.21.2007",
  422: "35.11.22.2001",
  423: "35.11.22.2002",
  424: "35.11.22.2003",
  425: "35.11.22.2004",
  426: "35.11.22.2005",
  427: "35.11.22.2006",
  428: "35.11.22.2007",
  429: "35.11.22.2008",
  430: "35.11.23.2001",
  431: "35.11.23.2002",
  432: "35.11.23.2003",
  433: "35.11.23.2004",
  434: "35.11.23.2005",
  435: "35.11.23.2006",
  436: "35.11.23.2007",
  437: "35.11.23.2008",
  438: "35.11.23.2009",
  499: "35.11.03.2001",
};

export default {
  name: "RekapPotensiDesa",

  data() {
    return {
      loading: true,
      exportLoading: false,
      errorMsg: null,
      potensiSpasial: [],
      lastUpdatedText: "",
      lastUpdatedShort: "",

      search: "",
      selectedKategori: null,
      filterJenis: null,
      filterDesa: null,

      sortBy: "total_desc",
      sortOptions: [
        { text: "Total Potensi Terbanyak", value: "total_desc" },
        { text: "Total Potensi Tersedikit", value: "total_asc" },
        { text: "Nama Desa A-Z", value: "nama_asc" },
      ],

      expanded: [],
      headers: [
        { text: "No", value: "no", sortable: false, width: 60 },
        { text: "Nama Desa", value: "nama_desa" },
        { text: "Kecamatan", value: "kecamatan", sortable: false },
        { text: "Total Potensi", value: "total", align: "center", width: 130 },
        { text: "Kategori Terbanyak", value: "topKategori", sortable: false },
        { text: "Rincian Kategori", value: "rincian", sortable: false },
        { text: "", value: "data-table-expand", sortable: false },
      ],

      categoryColorMap: {},

      detailDialog: false,
      detailItem: null,
      detailVideo: null,
      detailPhotos: [],
      detailCarouselIndex: 0,

      belumTerdataDialog: false,
      belumTerdataSearch: "",

      map: null,
      mapLoading: true,
      villageLayer: null,
      villageDistrictMap: {},
      allVillageEntries: [],
      legendBuckets: [],
    };
  },

  computed: {
    detailMedia() {
      const media = [];

      if (this.detailVideo) {
        media.push({ type: "video", url: this.detailVideo.url });
      }

      this.detailPhotos.forEach((item) => {
        media.push({ type: "image", url: item.url });
      });

      return media;
    },

    totalPotensi() {
      return this.potensiSpasial.length;
    },

    totalDesa() {
      return this.desaRekap.length;
    },

    totalDesaBondowoso() {
      return TOTAL_DESA_KELURAHAN_BONDOWOSO;
    },

    totalKecamatanBondowoso() {
      return TOTAL_KECAMATAN_BONDOWOSO;
    },

    cakupanDesaPercent() {
      return Math.min(
        100,
        Math.round((this.totalDesa / TOTAL_DESA_KELURAHAN_BONDOWOSO) * 100)
      );
    },

    totalKategori() {
      return this.categoryStats.length;
    },

    topKategori() {
      if (!this.categoryStats.length) return { nama: "", count: 0 };
      return this.categoryStats[0];
    },

    categoryStats() {
      const desaSets = {};
      const order = [];

      this.potensiSpasial.forEach((item) => {
        const nama = (item.nama_kategori || "Lainnya").trim();
        const namaDesa = (item.nama_desa_raw || "").trim() || "Tanpa Keterangan Desa";

        if (!desaSets[nama]) {
          desaSets[nama] = new Set();
          order.push(nama);
        }
        desaSets[nama].add(namaDesa);
      });

      const totalDesaAll = this.totalDesa || 1;

      return order
        .map((nama, idx) => ({
          nama,
          count: desaSets[nama].size,
          percent: Math.round((desaSets[nama].size / totalDesaAll) * 100),
          color: this.categoryColor(nama, idx),
          icon: this.categoryIcon(nama),
        }))
        .sort((a, b) => b.count - a.count);
    },

    categoryPointStats() {
      const counts = {};
      const order = [];

      this.potensiSpasial.forEach((item) => {
        const nama = (item.nama_kategori || "Lainnya").trim();
        if (!counts[nama]) {
          counts[nama] = 0;
          order.push(nama);
        }
        counts[nama]++;
      });

      const total = this.totalPotensi || 1;

      return order
        .map((nama, idx) => ({
          nama,
          count: counts[nama],
          percent: Math.round((counts[nama] / total) * 100),
          color: this.categoryColor(nama, idx),
        }))
        .sort((a, b) => b.count - a.count);
    },

    donutSegments() {
      const stats = this.categoryPointStats;
      const top = stats.slice(0, 8);
      const rest = stats.slice(8);

      const list = [...top];
      if (rest.length) {
        const restCount = rest.reduce((s, r) => s + r.count, 0);
        list.push({
          nama: "Lainnya",
          count: restCount,
          percent: Math.round((restCount / (this.totalPotensi || 1)) * 100),
          color: "#B0BEC5",
        });
      }

      const circumference = 2 * Math.PI * 80;
      let offsetAcc = 0;
      const total = this.totalPotensi || 1;

      return list.map((seg) => {
        const fraction = seg.count / total;
        const length = fraction * circumference;
        const dashArray = `${length} ${circumference - length}`;
        const dashOffset = -offsetAcc;
        offsetAcc += length;
        return { ...seg, dashArray, dashOffset };
      });
    },

    jenisOptions() {
      const set = new Set();
      this.potensiSpasial.forEach((item) => {
        const nm = (item.nama_jenis || "").trim();
        if (nm) set.add(nm);
      });
      return Array.from(set).sort((a, b) => a.localeCompare(b));
    },

    desaOptions() {
      return this.desaRekap
        .map((d) => ({
          text: d.kecamatan ? `${d.nama_desa} (${d.kecamatan})` : d.nama_desa,
          value: d.key,
        }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },

    filterDesaLabel() {
      if (!this.filterDesa) return "";
      const found = this.desaRekap.find((d) => d.key === this.filterDesa);
      if (!found) return "";
      return found.kecamatan
        ? `${found.nama_desa} (${found.kecamatan})`
        : found.nama_desa;
    },

    topJenis() {
      const counts = {};
      const order = [];
      const kategoriByJenis = {};

      this.potensiSpasial.forEach((item) => {
        const nm = (item.nama_jenis || "").trim();
        if (!nm) return;
        if (!counts[nm]) {
          counts[nm] = 0;
          order.push(nm);
          kategoriByJenis[nm] = item.nama_kategori || "";
        }
        counts[nm]++;
      });

      const max = Math.max(1, ...order.map((n) => counts[n]));

      return order
        .map((nama) => ({
          nama,
          count: counts[nama],
          kategori: kategoriByJenis[nama],
          percent: Math.round((counts[nama] / max) * 100),
        }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 5);
    },

    topDesa() {
      return [...this.desaRekap].sort((a, b) => b.total - a.total).slice(0, 5);
    },

    kecamatanStats() {
      const counts = {};

      this.potensiSpasial.forEach((item) => {
        const kec =
          (item.nama_kecamatan || "").trim() ||
          this.villageDistrictMap[this.normalizeText(item.nama_desa_raw).toLowerCase()];
        if (!kec) return;
        counts[kec] = (counts[kec] || 0) + 1;
      });

      return Object.keys(counts)
        .map((nama) => ({ nama, count: counts[nama] }))
        .sort((a, b) => b.count - a.count);
    },

    kelengkapanStats() {
      const total = this.totalPotensi || 1;
      let foto = 0;
      let video = 0;
      let deskripsi = 0;
      let pic = 0;
      let koordinat = 0;

      this.potensiSpasial.forEach((item) => {
        const media = this.parseFotoField(item.foto);
        if (media.some((m) => m.type === "foto")) foto++;
        if (media.some((m) => m.type === "video")) video++;
        if (this.normalizeText(item.deskripsi)) deskripsi++;
        if (this.normalizeText(item.pic)) pic++;

        const lat = Number(item.latitude);
        const lng = Number(item.longitude);
        if (isFinite(lat) && isFinite(lng) && lat !== 0 && lng !== 0) koordinat++;
      });

      const pct = (n) => Math.round((n / total) * 100);

      return [
        {
          label: "Foto tersedia",
          icon: "mdi-camera-outline",
          color: "#1E88E5",
          percent: pct(foto),
        },
        {
          label: "Deskripsi tersedia",
          icon: "mdi-text-box-outline",
          color: "#00BCD4",
          percent: pct(deskripsi),
        },
        {
          label: "PIC / Narahubung",
          icon: "mdi-account-circle-outline",
          color: "#CFA22D",
          percent: pct(pic),
        },
        {
          label: "Koordinat lengkap",
          icon: "mdi-map-marker-check-outline",
          color: "#018c74",
          percent: pct(koordinat),
        },
      ];
    },

    desaBelumTerdata() {
      if (!this.allVillageEntries.length) return [];
      const dataKeys = new Set(this.desaRekap.map((d) => d.key));

      return this.allVillageEntries
        .filter((v) => !dataKeys.has(this.desaKey(v.nama, v.kecamatan, v.kode)))
        .map((v) => ({
          nama: v.nama,
          kecamatan: v.kecamatan,
          key: this.desaKey(v.nama, v.kecamatan, v.kode),
        }))
        .sort((a, b) => a.nama.localeCompare(b.nama));
    },

    filteredBelumTerdata() {
      const raw = this.belumTerdataSearch;
      if (!raw || typeof raw !== "string") return this.desaBelumTerdata;
      const q = raw.trim().toLowerCase();
      if (!q) return this.desaBelumTerdata;
      return this.desaBelumTerdata.filter(
        (v) =>
          v.nama.toLowerCase().includes(q) ||
          (v.kecamatan && v.kecamatan.toLowerCase().includes(q))
      );
    },

    desaCountMap() {
      const map = {};
      this.desaRekap.forEach((d) => {
        map[d.key] = d.total;
      });
      return map;
    },

    autoInsights() {
      const list = [];
      const stats = this.categoryStats;
      const kecList = this.kecamatanStats;

      if (stats.length) {
        list.push({
          icon: "mdi-check-circle",
          color: "#1E88E5",
          text: `<b>${stats[0].percent}%</b> desa memiliki potensi di kategori <b>${stats[0].nama}</b>.`,
        });
      }

      if (kecList.length) {
        const top = kecList[0];
        list.push({
          icon: "mdi-medal-outline",
          color: "#7C4DFF",
          text: `Kecamatan <b>${top.nama}</b> memiliki potensi paling banyak yaitu <b>${top.count}</b> titik.`,
        });
      }

      if (kecList.length > 1) {
        const bottom = kecList[kecList.length - 1];
        list.push({
          icon: "mdi-checkbox-marked-circle-outline",
          color: "#018c74",
          text: `Kecamatan <b>${bottom.nama}</b> memiliki data paling sedikit yaitu <b>${bottom.count}</b> titik.`,
        });
      }

      if (this.desaBelumTerdata.length) {
        list.push({
          icon: "mdi-alert",
          color: "#FF9800",
          text: `<b>${this.desaBelumTerdata.length} desa</b> belum mempunyai data potensi sama sekali.`,
        });
      }

      const catPoint = this.categoryPointStats;
      if (catPoint.length) {
        list.push({
          icon: "mdi-star-circle-outline",
          color: "#E94364",
          text: `Potensi <b>${catPoint[0].nama}</b> mendominasi dengan <b>${catPoint[0].percent}%</b> dari total titik potensi.`,
        });
      }

      return list;
    },

    activeFilterCount() {
      let n = 0;
      if (this.selectedKategori) n++;
      if (this.filterJenis) n++;
      if (this.filterDesa) n++;
      if (this.search) n++;
      return n;
    },

    desaRekap() {
      const groups = {};

      this.potensiSpasial.forEach((item) => {
        const namaDesa = (item.nama_desa_raw || "").trim() || "Tanpa Keterangan Desa";
        const namaKecamatan =
          (item.nama_kecamatan || "").trim() ||
          this.villageDistrictMap[this.normalizeText(namaDesa).toLowerCase()] ||
          "";

        const kodeDesa =
          DESA_ID_TO_KODE_BPS[item.desa_id] || (item.kode_desa || "").trim();

        const namaKategori = (item.nama_kategori || "Lainnya").trim();
        if (namaDesa.toLowerCase().includes("klabang")) {
          console.log("DATA klabang:", {
            desa_id: item.desa_id,
            kodeDariMap: DESA_ID_TO_KODE_BPS[item.desa_id],
            kodeDesaFinal: kodeDesa,
            namaKecamatan,
            key: this.desaKey(namaDesa, namaKecamatan, kodeDesa),
          });
        }
        const key = this.desaKey(namaDesa, namaKecamatan, kodeDesa);

        if (!groups[key]) {
          groups[key] = {
            nama_desa: namaDesa,
            kecamatan: namaKecamatan,
            kode_desa: kodeDesa,
            total: 0,
            perKategori: {},
            items: [],
          };
        }

        const g = groups[key];
        g.total++;
        g.perKategori[namaKategori] = (g.perKategori[namaKategori] || 0) + 1;
        g.items.push(item);
      });

      const list = Object.keys(groups).map((key) => {
        const g = groups[key];
        const rincianAll = Object.keys(g.perKategori)
          .map((nama) => ({ nama, count: g.perKategori[nama] }))
          .sort((a, b) => b.count - a.count);

        return {
          key,
          nama_desa: g.nama_desa,
          kecamatan: g.kecamatan,
          total: g.total,
          topKategori: rincianAll[0] ? rincianAll[0].nama : "-",
          rincianTampil: rincianAll.slice(0, 3),
          rincianSisa: Math.max(0, rincianAll.length - 3),
          items: g.items,
        };
      });

      return list.sort((a, b) => b.total - a.total);
    },

    filteredDesaRekap() {
      let list = this.desaRekap;

      if (this.search) {
        const q = this.search.trim().toLowerCase();
        list = list.filter((d) => d.nama_desa.toLowerCase().includes(q));
      }

      if (this.filterDesa) {
        list = list.filter((d) => d.key === this.filterDesa);
      }

      if (this.selectedKategori) {
        list = list.filter(
          (d) =>
            d.items.filter(
              (i) => (i.nama_kategori || "").trim() === this.selectedKategori
            ).length > 0
        );
      }

      if (this.filterJenis) {
        list = list.filter(
          (d) =>
            d.items.filter((i) => (i.nama_jenis || "").trim() === this.filterJenis)
              .length > 0
        );
      }

      list = [...list];

      if (this.sortBy === "total_desc") {
        list.sort((a, b) => b.total - a.total);
      } else if (this.sortBy === "total_asc") {
        list.sort((a, b) => a.total - b.total);
      } else if (this.sortBy === "nama_asc") {
        list.sort((a, b) => a.nama_desa.localeCompare(b.nama_desa));
      }

      return list.map((item, idx) => ({ ...item, no: idx + 1 }));
    },
  },

  mounted() {
    this.loadData();
    this.$nextTick(() => this.initDistrictMap());
  },

  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  },

  methods: {
    kecamatanFromKode(kode) {
      const k = this.normalizeText(kode);
      if (!k) return "";
      const parts = k.split(".");
      if (parts.length < 3) return "";
      const prefix = parts.slice(0, 3).join(".");
      return KECAMATAN_CODE_MAP[prefix] || "";
    },

    async loadData() {
      this.loading = true;
      this.errorMsg = null;

      try {
        const potensiSpasial = await getPotensiSpasial();
        this.applyMasterData(Array.isArray(potensiSpasial) ? potensiSpasial : []);
      } catch (e) {
        console.error("Gagal memuat rekap potensi desa", e);
        this.errorMsg = "Tidak dapat terhubung ke server data.";
      } finally {
        this.loading = false;
        this.$nextTick(() => this.refreshDistrictColors());
      }
    },

    applyMasterData(potensiSpasial) {
      this.potensiSpasial = potensiSpasial;

      const now = Date.now();
      this.lastUpdatedText = new Date(now).toLocaleString("id-ID", {
        dateStyle: "medium",
        timeStyle: "short",
      });
      this.lastUpdatedShort = new Date(now).toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
      });
    },

    determineMediaType(filename) {
      const ext = String(filename).split(".").pop().toLowerCase();
      const videoExt = ["mp4", "mov", "avi", "mkv", "webm"];
      return videoExt.includes(ext) ? "video" : "foto";
    },

    parseFotoField(fotoRaw) {
      if (!fotoRaw) return [];

      let arr = fotoRaw;
      if (typeof fotoRaw === "string") {
        try {
          arr = JSON.parse(fotoRaw);
        } catch (e) {
          return [];
        }
      }

      if (!Array.isArray(arr)) return [];

      return arr.map((filename) => ({
        filename,
        url: `${MEDIA_BASE_URL}${filename}`,
        type: this.determineMediaType(filename),
      }));
    },

    openDetail(item) {
      this.detailItem = {
        nama: item.toponim || item.nama_sub_jenis || "-",
        nama_kategori: item.nama_kategori || "",
        nama_jenis: item.nama_jenis || "",
        deskripsi: item.deskripsi || "",
        nama_desa_raw: item.nama_desa_raw || "",
        kecamatan:
          item.nama_kecamatan ||
          this.villageDistrictMap[this.normalizeText(item.nama_desa_raw).toLowerCase()] ||
          "",
        alamat: item.alamat || "",
        pic: item.pic || "",
      };

      const media = this.parseFotoField(item.foto);

      this.detailVideo = media.find((m) => m.type === "video") || null;
      this.detailPhotos = media.filter((m) => m.type === "foto");
      this.detailCarouselIndex = 0;

      this.detailDialog = true;
    },

    closeDetail() {
      this.detailDialog = false;
      this.detailItem = null;
      this.detailVideo = null;
      this.detailPhotos = [];
    },

    categoryColor(nama, idxHint) {
      if (!nama) return "#9E9E9E";
      if (this.categoryColorMap[nama]) return this.categoryColorMap[nama];

      const idx =
        idxHint !== undefined ? idxHint : Object.keys(this.categoryColorMap).length;
      const color = CATEGORY_COLOR_PALETTE[idx % CATEGORY_COLOR_PALETTE.length];
      this.categoryColorMap[nama] = color;
      return color;
    },

    categoryIcon(nama) {
      const k = String(nama || "").toLowerCase();
      if (k.includes("wisata")) return "mdi-map-marker-star";
      if (k.includes("ternak")) return "mdi-cow";
      if (k.includes("ikan")) return "mdi-fish";
      if (k.includes("tani") || k.includes("pertanian")) return "mdi-sprout";
      if (k.includes("umkm") || k.includes("dagang")) return "mdi-store-outline";
      if (k.includes("industri")) return "mdi-factory";
      return "mdi-map-marker-radius";
    },

    toggleKategoriFilter(nama) {
      this.selectedKategori = this.selectedKategori === nama ? null : nama;
    },

    toggleDesaFilter(namaDesa, kecamatan, kodeDesa) {
      const key = this.desaKey(namaDesa, kecamatan, kodeDesa);
      this.filterDesa = this.filterDesa === key ? null : key;
    },

    toggleJenisFilter(nama) {
      this.filterJenis = this.filterJenis === nama ? null : nama;
    },

    clearFilters() {
      this.search = "";
      this.selectedKategori = null;
      this.filterJenis = null;
      this.filterDesa = null;
    },

    normalizeText(val) {
      return String(val || "")
        .trim()
        .replace(/\s+/g, " ");
    },

    desaKey(namaDesa, kecamatan, kodeDesa) {
      const kodeDigits = this.normalizeText(kodeDesa).replace(/[^0-9]/g, "");
      if (kodeDigits.length >= 8) return `kode:${kodeDigits}`;

      const d = this.normalizeText(namaDesa).toLowerCase();
      const k = this.normalizeKecamatan(kecamatan);
      return k ? `nama:${d}__${k}` : `nama:${d}`;
    },

    normalizeKecamatan(val) {
      return this.normalizeText(val)
        .replace(/^kecamatan\s+/i, "")
        .replace(/^kec\.?\s+/i, "")
        .toLowerCase();
    },

    goToPeta() {
      this.$router.push({ name: "PotensiDesa" });
    },

    openBelumTerdataDialog(nm) {
      this.belumTerdataSearch = typeof nm === "string" ? nm : "";
      this.belumTerdataDialog = true;
    },

    printPage() {
      window.print();
    },

    async exportExcel() {
      this.exportLoading = true;

      try {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = "Pemerintah Kabupaten Bondowoso";
        workbook.created = new Date();

        const titleFont = { bold: true, size: 14, color: { argb: "FF16221E" } };
        const subtitleFont = { italic: true, size: 10, color: { argb: "FF6B7A75" } };
        const headerFont = { bold: true, size: 11, color: { argb: "FFFFFFFF" } };
        const thinBorder = {
          top: { style: "thin", color: { argb: "FFD9D9D9" } },
          left: { style: "thin", color: { argb: "FFD9D9D9" } },
          bottom: { style: "thin", color: { argb: "FFD9D9D9" } },
          right: { style: "thin", color: { argb: "FFD9D9D9" } },
        };

        const sheet1 = workbook.addWorksheet("Rekap Potensi Desa", {
          views: [{ state: "frozen", ySplit: 4 }],
        });

        const columns1 = [
          { header: "No", width: 6 },
          { header: "Nama Desa", width: 28 },
          { header: "Kecamatan", width: 22 },
          { header: "Total Potensi", width: 14 },
          { header: "Kategori Terbanyak", width: 24 },
          { header: "Rincian Kategori", width: 55 },
        ];
        columns1.forEach((c, idx) => {
          sheet1.getColumn(idx + 1).width = c.width;
        });

        sheet1.mergeCells(1, 1, 1, columns1.length);
        const title1 = sheet1.getCell(1, 1);
        title1.value = "REKAP POTENSI DESA KABUPATEN BONDOWOSO";
        title1.font = titleFont;
        title1.alignment = { horizontal: "center", vertical: "middle" };
        sheet1.getRow(1).height = 26;

        sheet1.mergeCells(2, 1, 2, columns1.length);
        const sub1 = sheet1.getCell(2, 1);
        sub1.value = `Diperbarui: ${this.lastUpdatedText || "-"}  |  Menampilkan ${
          this.filteredDesaRekap.length
        } dari ${TOTAL_DESA_KELURAHAN_BONDOWOSO} desa/kelurahan se-Kabupaten Bondowoso`;
        sub1.font = subtitleFont;
        sub1.alignment = { horizontal: "center" };

        const headerRow1 = sheet1.addRow(columns1.map((c) => c.header));
        headerRow1.eachCell((cell) => {
          cell.font = headerFont;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF018C74" },
          };
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
          cell.border = thinBorder;
        });
        headerRow1.height = 22;

        this.filteredDesaRekap.forEach((d) => {
          const rincian = Object.entries(
            d.items.reduce((acc, i) => {
              const nm = (i.nama_kategori || "Lainnya").trim();
              acc[nm] = (acc[nm] || 0) + 1;
              return acc;
            }, {})
          )
            .map(([nm, c]) => `${nm}: ${c}`)
            .join(" | ");

          const row = sheet1.addRow([
            d.no,
            d.nama_desa,
            d.kecamatan || "-",
            d.total,
            d.topKategori,
            rincian,
          ]);

          row.eachCell((cell, colNumber) => {
            cell.border = thinBorder;
            cell.alignment =
              colNumber === 1 || colNumber === 4
                ? { horizontal: "center", vertical: "middle" }
                : { vertical: "middle", wrapText: colNumber === 6 };
          });

          if (row.number % 2 === 0) {
            row.eachCell((cell) => {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFF4F7F6" },
              };
            });
          }
        });

        sheet1.autoFilter = {
          from: { row: 3, column: 1 },
          to: { row: 3, column: columns1.length },
        };

        const sheet2 = workbook.addWorksheet("Desa Belum Terdata");
        const columns2 = [
          { header: "No", width: 6 },
          { header: "Nama Desa", width: 30 },
          { header: "Kecamatan", width: 24 },
        ];
        columns2.forEach((c, idx) => {
          sheet2.getColumn(idx + 1).width = c.width;
        });

        sheet2.mergeCells(1, 1, 1, columns2.length);
        const title2 = sheet2.getCell(1, 1);
        title2.value = "REKAP DESA BELUM TERDATA POTENSI";
        title2.font = titleFont;
        title2.alignment = { horizontal: "center", vertical: "middle" };
        sheet2.getRow(1).height = 26;

        sheet2.mergeCells(2, 1, 2, columns2.length);
        const sub2 = sheet2.getCell(2, 1);
        sub2.value = `Total ${this.desaBelumTerdata.length} desa/kelurahan belum memiliki data potensi`;
        sub2.font = subtitleFont;
        sub2.alignment = { horizontal: "center" };

        const headerRow2 = sheet2.addRow(columns2.map((c) => c.header));
        headerRow2.eachCell((cell) => {
          cell.font = headerFont;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFE94364" },
          };
          cell.alignment = { horizontal: "center", vertical: "middle" };
          cell.border = thinBorder;
        });
        headerRow2.height = 22;

        this.desaBelumTerdata.forEach((v, idx) => {
          const row = sheet2.addRow([idx + 1, v.nama, v.kecamatan || "-"]);
          row.eachCell((cell, colNumber) => {
            cell.border = thinBorder;
            cell.alignment =
              colNumber === 1
                ? { horizontal: "center", vertical: "middle" }
                : { vertical: "middle" };
          });
          if (row.number % 2 === 0) {
            row.eachCell((cell) => {
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFF3F0" },
              };
            });
          }
        });

        if (!this.desaBelumTerdata.length) {
          const row = sheet2.addRow(["", "Semua desa sudah memiliki data potensi.", ""]);
          row.getCell(2).font = { italic: true, color: { argb: "FF6B7A75" } };
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "rekap-potensi-desa-bondowoso.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Gagal membuat file Excel", e);
        this.errorMsg = "Gagal membuat file Excel. Silakan coba lagi.";
      } finally {
        this.exportLoading = false;
      }
    },

    mediaUrl(filename) {
      return filename ? `${MEDIA_BASE_URL}${filename}` : null;
    },


    async initDistrictMap() {
      this.mapLoading = true;

      this.map = L.map("rekap-map", {
        zoomControl: false,
        scrollWheelZoom: false,
      }).setView([-7.909473813658169, 113.8981324393563], 10.3);

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
        maxZoom: 19,
      }).addTo(this.map);

      L.control.zoom({ position: "bottomright" }).addTo(this.map);

      await this.loadVillageBoundary();

      this.mapLoading = false;

      this.$nextTick(() => {
        setTimeout(() => {
          if (this.map) this.map.invalidateSize();
        }, 300);
      });
    },

    async loadVillageBoundary() {
      try {
        const response = await fetch("/images/35.11_desa.geojson");
        const geojson = await response.json();

        const map = {};
        const entries = [];

        (geojson?.features || []).forEach((feature) => {
          const p = feature.properties || {};
          const namaDesa = this.normalizeText(p.nama_desa || p.NAMOBJ || p.WADMKD || "");
          const kodeDesa = this.normalizeText(p.kode_desa || "");

          const namaKec =
            this.normalizeText(
              p.nm_kecamatan ||
                p.NAMOBJ_1 ||
                p.WADMKC ||
                p.kecamatan ||
                p.nama_kecamatan ||
                ""
            ) || this.kecamatanFromKode(kodeDesa);

          if (!namaDesa) return;

          entries.push({ nama: namaDesa, kecamatan: namaKec, kode: kodeDesa });
          if (namaKec && !map[namaDesa.toLowerCase()]) {
            map[namaDesa.toLowerCase()] = namaKec;
          }
        });

        this.villageDistrictMap = map;
        this.allVillageEntries = entries;

        this.villageLayer = L.geoJSON(geojson, {
          style: (feature) => this.villageStyle(feature),
          onEachFeature: (feature, layer) => {
            const nama = this.villageFeatureName(feature);
            const kecamatan = this.villageFeatureKecamatan(feature);
            const kode = this.villageFeatureKode(feature);
            const count = this.villageCount(nama, kecamatan, kode);

            if (nama.toLowerCase().includes("klabang")) {
              console.log("PETA klabang:", {
                nama,
                kecamatan,
                kode,
                key: this.desaKey(nama, kecamatan, kode),
              });
            }

            layer.bindTooltip(
              `<b>${nama}</b>${
                kecamatan
                  ? ` <span style="font-weight:400">(Kec. ${kecamatan})</span>`
                  : ""
              }<br/>${count} potensi`,
              {
                sticky: true,
                direction: "top",
                className: "label-kecamatan-count",
              }
            );

            layer.on({
              mouseover: (e) => {
                e.target.setStyle({ weight: 2.5, fillOpacity: 0.9 });
              },
              mouseout: (e) => {
                if (this.villageLayer) this.villageLayer.resetStyle(e.target);
              },
              click: (e) => {
                L.DomEvent.stopPropagation(e);
                this.toggleDesaFilter(nama, kecamatan, kode);
              },
            });
          },
        }).addTo(this.map);

        this.buildLegend();
        console.log("contoh kode_desa dari geojson:", geojson.features[0].properties);
      } catch (e) {
        console.error("Gagal memuat batas desa", e);
      }
    },

    villageFeatureName(feature) {
      const p = feature.properties || {};
      return this.normalizeText(p.nama_desa || p.NAMOBJ || p.WADMKD || "Desa");
    },

    villageFeatureKecamatan(feature) {
      const p = feature.properties || {};
      const namaKecExplisit = this.normalizeText(
        p.nm_kecamatan || p.NAMOBJ_1 || p.WADMKC || p.kecamatan || p.nama_kecamatan || ""
      );
      if (namaKecExplisit) return namaKecExplisit;

      const kode = this.normalizeText(p.kode_desa || p.KDEPUM || p.KDCPUM || "");
      return this.kecamatanFromKode(kode);
    },

    villageFeatureKode(feature) {
      const p = feature.properties || {};
      return this.normalizeText(p.kode_desa || p.KDEPUM || p.KDCPUM || "");
    },

    villageCount(nama, kecamatan, kode) {
      return this.desaCountMap[this.desaKey(nama, kecamatan, kode)] || 0;
    },

    toggleDesaFilter(namaDesa, kecamatan, kodeDesa) {
      const key = this.desaKey(namaDesa, kecamatan, kodeDesa);
      this.filterDesa = this.filterDesa === key ? null : key;
    },

    mapColorBuckets() {
      const counts = Object.values(this.desaCountMap);
      const max = Math.max(1, ...counts);
      const t1 = Math.round(max * 0.15);
      const t2 = Math.round(max * 0.35);
      const t3 = Math.round(max * 0.6);
      const t4 = Math.round(max * 0.85);
      return { max, t1, t2, t3, t4 };
    },

    bucketColor(count) {
      const { t1, t2, t3, t4 } = this.mapColorBuckets();
      if (!count) return "#EDEFF1";
      if (count > t4) return MAP_COLOR_SCALE[4];
      if (count > t3) return MAP_COLOR_SCALE[3];
      if (count > t2) return MAP_COLOR_SCALE[2];
      if (count > t1) return MAP_COLOR_SCALE[1];
      return MAP_COLOR_SCALE[0];
    },

    villageStyle(feature) {
      const nama = this.villageFeatureName(feature);
      const kecamatan = this.villageFeatureKecamatan(feature);
      const kode = this.villageFeatureKode(feature);
      const key = this.desaKey(nama, kecamatan, kode);
      const count = this.villageCount(nama, kecamatan, kode);
      const isSelected = this.filterDesa === key;

      return {
        color: isSelected ? "#CFA22D" : "#ffffff",
        weight: isSelected ? 3 : 1,
        opacity: 1,
        fillColor: this.bucketColor(count),
        fillOpacity: isSelected ? 0.9 : 0.75,
      };
    },

    buildLegend() {
      const { t1, t2, t3, t4, max } = this.mapColorBuckets();
      this.legendBuckets = [
        { label: `> ${t4}`, color: MAP_COLOR_SCALE[4] },
        { label: `${t3 + 1} - ${t4}`, color: MAP_COLOR_SCALE[3] },
        { label: `${t2 + 1} - ${t3}`, color: MAP_COLOR_SCALE[2] },
        { label: `${t1 + 1} - ${t2}`, color: MAP_COLOR_SCALE[1] },
        { label: `1 - ${t1}`, color: MAP_COLOR_SCALE[0] },
        { label: "Tidak ada data", color: "#EDEFF1" },
      ];
      if (!max) this.legendBuckets = [{ label: "Belum ada data", color: "#EDEFF1" }];
    },

    refreshDistrictColors() {
      if (!this.villageLayer) return;

      this.villageLayer.eachLayer((layer) => {
        const nama = this.villageFeatureName(layer.feature);
        const kecamatan = this.villageFeatureKecamatan(layer.feature);
        const count = this.villageCount(nama, kecamatan);

        layer.setStyle(this.villageStyle(layer.feature));

        if (layer.getTooltip()) {
          layer.setTooltipContent(
            `<b>${nama}</b>${
              kecamatan ? ` <span style="font-weight:400">(Kec. ${kecamatan})</span>` : ""
            }<br/>${count} potensi`
          );
        }
      });

      this.buildLegend();
    },
  },

  watch: {
    desaCountMap() {
      this.refreshDistrictColors();
    },
    filterDesa() {
      this.refreshDistrictColors();
    },
  },
};
</script>

<style scoped>
.gov-background {
  position: fixed;
  inset: 0;
  background: #f3f5f7;
  z-index: 0;
}

.loading-box {
  min-height: 300px;
}

.gov-header {
  background: #ffffff !important;
  border-bottom: 1px solid #e7ebee !important;
  box-shadow: 0 2px 10px rgba(16, 40, 34, 0.04) !important;
}

.gov-title {
  font-size: 19px;
  font-weight: 800;
  color: #16221e;
  line-height: 1.2;
}

.gov-subtitle {
  font-size: 12px;
  color: #8b979e;
  font-weight: 500;
}

.gov-updated {
  font-size: 12.5px;
}

.gov-btn-primary {
  background: linear-gradient(90deg, #016b62 0%, #018c74 45%, #8bcdc6 100%) !important;
  color: #ffffff !important;
  text-transform: none;
  font-weight: 700;
  border-radius: 10px;
  letter-spacing: 0;
}

.gov-card {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e7ebee;
  box-shadow: 0 2px 12px rgba(16, 40, 34, 0.04);
}

.h-100 {
  height: 100%;
}

.filter-bar .filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #8b979e;
  margin-bottom: 4px;
}

.gov-select >>> .v-input__control .v-input__slot {
  min-height: 40px !important;
  border-radius: 10px !important;
  background: #f7f9fa;
}

.sort-select {
  min-width: 200px;
}

.stat-card {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e7ebee;
  box-shadow: 0 2px 12px rgba(16, 40, 34, 0.04);
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-icon-box {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.stat-number {
  font-size: 26px;
  font-weight: 900;
  color: #16221e;
  line-height: 1.1;
}

.stat-number-text {
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stat-label {
  font-size: 11.5px;
  color: #8b979e;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.stat-sublabel {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #018c74;
  text-transform: none;
  letter-spacing: normal;
  margin-top: 2px;
}

.map-card-wrap {
  overflow: hidden;
}

.map-shell {
  position: relative;
  height: 480px;
}

#rekap-map {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: #eef2f2;
}

.map-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
}

.map-legend-box {
  position: absolute;
  left: 14px;
  bottom: 14px;
  z-index: 4;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 12px;
  padding: 10px 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  font-size: 12px;
}

.legend-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  color: #45524d;
}

.legend-swatch {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  flex-shrink: 0;
  display: inline-block;
}

.insight-card {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdfc 100%);
}

.insight-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 9px 4px;
  border-bottom: 1px dashed #eef2f1;
  font-size: 13px;
  color: #45524d;
  line-height: 1.5;
}

.insight-row:last-child {
  border-bottom: none;
}

.insight-text >>> b {
  color: #16221e;
}

.rank-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 6px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.rank-row:hover {
  background: rgba(1, 140, 116, 0.06);
}

.rank-row.is-active {
  background: rgba(1, 140, 116, 0.12);
}

.rank-index {
  width: 20px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 800;
  color: #8b979e;
}

.rank-label {
  width: 130px;
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 600;
  color: #16221e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.rank-track {
  flex: 1;
  height: 9px;
  border-radius: 999px;
  background: #eef2f1;
  overflow: hidden;
}

.rank-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.4s ease;
}

.rank-count {
  width: 42px;
  flex-shrink: 0;
  text-align: right;
  font-size: 13px;
  font-weight: 800;
  color: #16221e;
}

.donut-wrap {
  position: relative;
  width: 190px;
  height: 190px;
  margin: 4px auto 10px;
}

.donut-svg {
  width: 100%;
  height: 100%;
}

.donut-center {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.donut-total {
  font-size: 24px;
  font-weight: 900;
  color: #16221e;
}

.donut-total-label {
  font-size: 11px;
  color: #8b979e;
  font-weight: 700;
  text-transform: uppercase;
}

.donut-legend {
  max-height: 190px;
  overflow-y: auto;
}

.donut-legend-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 4px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12.5px;
}

.donut-legend-row:hover {
  background: rgba(1, 140, 116, 0.06);
}

.donut-legend-row.is-active {
  background: rgba(1, 140, 116, 0.12);
}

.donut-legend-label {
  flex: 1;
  color: #45524d;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.donut-legend-value {
  color: #8b979e;
  font-weight: 700;
  flex-shrink: 0;
}

.top-desa-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 6px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.top-desa-row:hover {
  background: rgba(1, 140, 116, 0.06);
}

.top-desa-medal {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  color: #fff;
  background: #b0bec5;
  flex-shrink: 0;
}

.medal-1 {
  background: #cfa22d;
}
.medal-2 {
  background: #9aa5ab;
}
.medal-3 {
  background: #b87333;
}

.top-desa-info {
  flex: 1;
  min-width: 0;
}

.top-desa-name {
  font-size: 13.5px;
  font-weight: 700;
  color: #16221e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-desa-kec {
  font-size: 11px;
  color: #8b979e;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-desa-count {
  font-size: 13.5px;
  font-weight: 800;
  color: #018c74;
  flex-shrink: 0;
}

.kelengkapan-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 2px;
}

.kelengkapan-label {
  width: 140px;
  flex-shrink: 0;
  font-size: 12.5px;
  font-weight: 600;
  color: #45524d;
}

.kelengkapan-track {
  flex: 1;
  height: 8px;
  border-radius: 999px;
  background: #eef2f1;
  overflow: hidden;
}

.kelengkapan-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.4s ease;
}

.kelengkapan-value {
  width: 38px;
  flex-shrink: 0;
  text-align: right;
  font-size: 12.5px;
  font-weight: 800;
  color: #16221e;
}

.belum-terdata-card {
  background: linear-gradient(180deg, #fff6f3 0%, #ffffff 60%);
  border-color: #fbd9ce;
}

.belum-terdata-list {
  margin: 0;
  padding-left: 18px;
  font-size: 13px;
  color: #45524d;
  line-height: 1.9;
}

.belum-terdata-kec {
  color: #8b979e;
  font-size: 11.5px;
  font-weight: 600;
  margin-left: 2px;
}

.belum-terdata-clickable {
  cursor: pointer;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.belum-terdata-clickable:hover {
  border-color: rgba(233, 67, 100, 0.4);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.belum-terdata-item {
  cursor: pointer;
  transition: color 0.15s ease;
}

.belum-terdata-item:hover {
  color: #e94364;
  text-decoration: underline;
}

.belum-terdata-more {
  cursor: pointer;
  color: #018c74;
  font-weight: 700;
}

.belum-terdata-more:hover {
  text-decoration: underline;
}

.belum-terdata-dialog-card {
  border-radius: 18px;
}

.belum-terdata-dialog-list {
  max-height: 55vh;
  overflow-y: auto;
}

.belum-terdata-dialog-row {
  display: flex;
  align-items: flex-start;
  padding: 10px 10px;
  border-radius: 10px;
  transition: background 0.15s ease;
}

.belum-terdata-dialog-row:hover {
  background: rgba(233, 67, 100, 0.06);
}

.rekap-table >>> table {
  border-collapse: separate;
}

.detail-desa-cell {
  background: #fafcfb;
}

.detail-item-card {
  background: #ffffff;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 10px 12px;
  height: 100%;
  cursor: pointer;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.detail-item-card:hover {
  border-color: rgba(1, 140, 116, 0.4);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.detail-btn {
  text-transform: none;
}

.detail-dialog-card {
  border-radius: 22px;
  overflow: hidden;
}

.hero-media {
  position: relative;
}

.hero-carousel {
  background: #eceff1;
}

.hero-img,
.hero-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.close-btn {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 9999 !important;
  width: 38px;
  height: 38px;
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
}

.media-type {
  position: absolute;
  left: 12px;
  top: 12px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  font-size: 11px;
  color: white;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 18px;
  backdrop-filter: blur(8px);
}

.media-count {
  position: absolute;
  right: 12px;
  bottom: 12px;
  padding: 5px 10px;
  font-size: 11px;
  color: white;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 18px;
}

.no-media {
  height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
}

.detail-title {
  font-size: 22px;
  font-weight: 700;
  color: #222;
  line-height: 1.3;
}

.info-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #555;
}

.description {
  margin-top: 18px;
  font-size: 13px;
  line-height: 1.8;
  color: #666;
}

::v-deep .label-kecamatan-count {
  background: rgba(255, 255, 255, 0.85) !important;
  border: none !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12) !important;
  color: #16221e !important;
  font-size: 11px !important;
  padding: 3px 8px !important;
  border-radius: 8px;
  text-align: center;
  backdrop-filter: blur(4px);
}

::v-deep .kec-label-inner {
  line-height: 1.3;
}

@media print {
  .no-print {
    display: none !important;
  }

  .gov-background {
    display: none !important;
  }

  .gov-card,
  .stat-card {
    box-shadow: none !important;
    border: 1px solid #ddd !important;
  }
}

@media (max-width: 600px) {
  .map-shell {
    height: 360px;
  }

  .rank-label {
    width: 90px;
  }
}
</style>
